import { useTranslation } from 'react-i18next';
import { Anchor, Button, Group, Text } from '@mantine/core';
import StatusScreen from '@/components/common/StatusScreen';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '@/lib/contacts';
import { ROUTES } from '@/routes/paths';

// Экран непредвиденной ошибки. Обновление может её повторить, поэтому есть выход на главную и контакты поддержки.
// Ссылки обычные, не маршрутизатора: экран работает и тогда, когда сам маршрутизатор не отрисовался.
export default function ErrorScreen() {
  const { t } = useTranslation();

  return (
    <StatusScreen title={t('errorScreen.title')} message={t('errorScreen.message')}>
      <Group justify="center">
        <Button onClick={() => window.location.reload()}>{t('errorScreen.reload')}</Button>
        <Button component="a" href={ROUTES.HOME} variant="default">
          {t('notFound.backHome')}
        </Button>
      </Group>
      <Text size="sm" c="gray.7">
        {t('errorScreen.support')}{' '}
        <Anchor href={ROUTES.SUPPORT_URL} target="_blank" rel="noopener noreferrer" c="brand.7" underline="always">
          {t('app.support')}
        </Anchor>
        {' · '}
        <Anchor href={`mailto:${CONTACT_EMAIL}`} c="brand.7" underline="always">
          {CONTACT_EMAIL}
        </Anchor>
        {' · '}
        <Anchor href={CONTACT_PHONE_HREF} c="brand.7" underline="always">
          {CONTACT_PHONE}
        </Anchor>
      </Text>
    </StatusScreen>
  );
}
